import React, { useState } from "react";
import Modal from "react-modal";
import CustomButton from "../components/CustomButton";

const EditVoucherComment = ({
  isModalVisible,
  setIsModalVisible,
  approveHandler,
  ids = [],
  totalAmount = "",
  title = "Voucher"
}) => {
  
  const onRequestClose = () => {
    setIsModalVisible({ ...isModalVisible, isOpen: false });
  };

  const [comment, setComment] = useState(isModalVisible?.data?.comment ? isModalVisible?.data?.comment : '');
  const [error, setError] = useState({ comment: false});
  
  
  return (
    <div className="flex justify-center items-center w-full">
      <Modal
        isOpen={isModalVisible.isOpen}
        onRequestClose={onRequestClose}
        style={{
          content: {
            display: "flex",
            justifyContent: "center",
            // alignItems: 'center',
            borderRadius: "1rem",
            background: "#fff",
            padding: "1.5rem",
            // margin: "8rem 20rem",
            width: "66%",
            inset: "0px",
            position: "relative",
            zIndex:99
          },
          overlay: {
            background: "#000000d6",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex:99
          },
        }}
      >
        <div className="w-full" style={{ maxHeight: '61vh'}}>
          {/* Header */}
          <div className="flex justify-between relative w-[100%] text-2xl font-semibold">
            Update Comment
            <div
              className="text-3xl cursor-pointer text-red-500 ml-4"
              onClick={() => setIsModalVisible(false)}
            >
              [x]
            </div>
          </div>
          <div className="mt-4">
            <div className="mt-4">WRITE COMMENT</div>
            <textarea
              className="h-40 w-full border text-2xl mt-2 p-2"
              value={comment}
              onChange={(e) => {
                setComment(e.target.value);
                setError(false);
              }}
            />
            {error.comment && (
              <span className="text-red-500 text-lg">
                {"Comment cannot be blank."}
              </span>
            )}
          </div>
          <div className="w-full flex justify-end">
            <CustomButton
              title="UPDATE"
              wrapperClassName="!px-10 mt-6 mb-4"
              style={{
                background: "white",
                color: "red",
                border: "1px solid red",
              }}
              onClick={() => {
                if(comment?.trim() === ''){
                  setError(prev => ({...prev, comment: true}))  
                }else{
                  approveHandler({
                    id: isModalVisible?.data?.id,
                    comment: comment,
                  });
                }
              }}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EditVoucherComment;
